import React from 'react';
import type PlanSettingsFindYourIssueType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/find-your-issue/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - find-your-issue page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsFindYourIssue = lazyForPaint<typeof PlanSettingsFindYourIssueType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-plan-settings-find-your-issue", jiraSpaEntry: "async-plan-settings-plan-settings-find-your-issue" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/find-your-issue'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsFindYourIssue = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsFindYourIssue}
		pageId="plan-settings-find-your-issue"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsFindYourIssue;
